import { Link, useLocation } from "react-router-dom";

import Icon from "components/Icon";
import PropTypes from "prop-types";
import React from "react";
import { Text } from "./Texts";
import colors from "styles/colors";
import styled from "styled-components";

const MenuItem = ({ route, icon, text, onClick, padding }) => {
  const location = useLocation();
  // const manageRoute = (location.pathname == '/dashboard/fb')?'/dashboard':location.pathname
  const active = route === location.pathname ? "active" : null;
  console.log("inMenuItem", route, icon, text, onClick, active);

  return (
    <MenuItemZone
      to={() => (route !== location.pathname ? route : location.pathname)}
      active={active}
      icon={icon}
      onClick={onClick}
      padding={padding}
    >
      {icon ? (
        <>
          <Icon name={icon} size="20px" color={route === location.pathname ? colors.primary : colors.menuText} />
          <MenuText active={active}>{text}</MenuText>
        </>
      ) : (
        <MenuText withoutIcon={true} active={active}>
          {text}
        </MenuText>
      )}
    </MenuItemZone>
  );
};

MenuItem.propTypes = {
  route: PropTypes.string,
  icon: PropTypes.string,
  text: PropTypes.string,
  padding: PropTypes.string,
};

export default MenuItem;

const MenuItemZone = styled(Link)`
  padding: ${(props) => (props.icon ? "8px 6px" : props.padding ? props.padding : "10px 10px 10px 26px")};
  color: ${(props) => (props.active ? colors.primary : colors.menuText)};
  border-radius: 0 4px 4px 0;
  border-left: ${(props) => (props.active ? `5px solid ${colors.primary}` : "5px solid transparent")};
  &:hover {
    cursor: pointer;
  }
  display: flex;
  align-items: center;
  text-decoration: none;
`;

const MenuText = styled(Text)`
  font-size: 14px;
  display: inline;
  color: inherit;
  padding-left: ${(props) => (props.withoutIcon ? "" : "6px")};
`;
